/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type ReportTypeEnum = 'internship-evaluation-interuniversity' | 'transgressive-behavior' | 'custom-query';

export const ReportTypeEnum = {
    InternshipEvaluationInteruniversity: 'internship-evaluation-interuniversity' as ReportTypeEnum,
    TransgressiveBehavior: 'transgressive-behavior' as ReportTypeEnum,
    CustomQuery: 'custom-query' as ReportTypeEnum
};

